import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme) => ({
container: {
flex: 1,
width: "100%",
maxWidth: "100%",
minHeight: "calc(100% - 48px)",
padding: 0,
backgroundColor: "transparent",
boxSizing: "border-box",
},
}));

const MainContainer = ({ children }) => {
const classes = useStyles();

return (
<Container className={classes.container} maxWidth={false} disableGutters>
{children}
</Container>
);
};

export default MainContainer;
